import { observer } from 'mobx-react-lite'
import { FC } from 'react'
import { GRAY_COLORS } from '../../lib/stitches'
import { useTreeState } from '../../stores/Root'
import { Row } from '../core/Components'

const Stripe: FC<{ width: string; backgroundColor: string }> = ({ width, backgroundColor }) => (
  <div
    style={{
      width: width,
      minWidth: width,
      height: '100%',
      backgroundColor: backgroundColor
    }}
  />
)

interface CompositionViewBackground {
  instrumentLoopWidthPX: number
  height: string
  style?: {}
  dark?: boolean
  scrollable?: boolean
}
const CompositionViewBackground: FC<CompositionViewBackground> = ({
  instrumentLoopWidthPX,
  height,
  dark,
  scrollable,
  style = {}
}) => {
  const { studio } = useTreeState()
  const iterator = Array.from(Array(studio.song.songDisplayLength + studio.extraBarsCount))
  return (
    <Row style={{ height: height, minHeight: scrollable && height, overflow: 'visible', ...style }}>
      {iterator.map((_, index) => {
        const isEven = index % 2 === 0
        return (
          <Stripe
            width={`${instrumentLoopWidthPX}px`}
            backgroundColor={
              isEven
                ? dark
                  ? GRAY_COLORS.gray005
                  : GRAY_COLORS.gray01
                : dark
                ? GRAY_COLORS.gray02
                : GRAY_COLORS.gray005
            }
            key={index}
          />
        )
      })}
    </Row>
  )
}

export default observer(CompositionViewBackground)
